const columns = [
  {
    headerLabel: 'rotativeInventory.dtInventory',
    type: 'date',
    field: 'date',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'center',
    type: 'general',
    field: 'storeCd',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'configurationFragment.branches',
    type: 'general',
    field: 'storeDesc',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'manualConsultFragment.lm',
    type: 'general',
    field: 'lmCd',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'order_status_details.description',
    type: 'general',
    field: 'productDesc',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'irc.sub-section',
    type: 'general',
    field: 'subsectionDesc',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'product.registration.date',
    type: 'date',
    field: 'inclusionDate',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'commercialManagement.lblGama',
    type: 'general',
    field: 'gamaCd',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'punctual.adjust.parameters.AVS',
    type: 'general',
    field: 'avs',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'ruptures.heartTitle',
    type: 'general',
    field: 'top2500',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'logistic.flux.type',
    type: 'general',
    field: 'logFluxType',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'supply.code',
    type: 'general',
    field: 'supplyCd',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'order_status_details.unit_measure',
    type: 'general',
    field: 'measureUnit',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'linearConference.report.c50',
    type: 'general',
    field: 'storeStockCount',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'supply.cd.stock',
    type: 'general',
    field: 'supplyStockFromCD',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'store.topping',
    type: 'general',
    field: 'storeTopageCount',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'supply.cd.topping',
    type: 'general',
    field: 'supplyTopageFromCD',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'buy.transference.order.number',
    type: 'general',
    field: 'buyOrderNr',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'order.delivery.date',
    type: 'date',
    field: 'deliveryDate',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'supplier.cd',
    type: 'general',
    field: 'supplierCd',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'supplier',
    type: 'general',
    field: 'supplierDesc',
    className: 'align-left',
    render: true,
    fixed: false,
    customWidth: 400,
  },
  {
    headerLabel: 'beeping.responsible',
    type: 'general',
    field: 'beepingResponsibleDesc',
    className: 'align-left',
    render: true,
    fixed: false,
  },
  {
    headerLabel: 'justificationsPa.justificationActive',
    type: 'general',
    field: 'beeped',
    className: 'align-left',
    render: true,
    fixed: false,
  },
]

export default columns
